<template>
  <ShareSpaceObjectCannotFetch v-if="failed_to_fetch" :object-type="$utils.removeLastChars(current_component, 1)" />
  <div v-if="object_to_display">
    <PlanEndUserView v-if="current_component == 'plans'" :plan="object_to_display" />
  </div>
</template>

<script>
import PlanEndUserView from "@/components/forms/PlanEndUserView.vue"

import ShareSpaceObjectCannotFetch from "./ShareSpaceObjectCannotFetch.vue"

import dataService from "@/services/data.service"
import { utils } from "@/store/helpers"
export default {
  components: { PlanEndUserView, ShareSpaceObjectCannotFetch },
  props: {},
  emits: [],
  data() {
    return {
      object_to_display: null,
      failed_to_fetch: false
    }
  },

  computed: {
    current_component() {
      return this.$route.params.object_type
    }
  },
  watch: {},

  created() {
    dataService[`get${utils.capitalize(utils.removeLastChars(this.current_component, 1))}`](this.$route.params.object_id)
      .then((res) => {
        this.object_to_display = res.data
      })
      .catch(() => {
        this.failed_to_fetch = true
      })
  },

  methods: {}
}
</script>
